import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { editVariance } from "../../../../../services/varianceService/model/varianceRequest/VarianceRequestSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";
import { TextField } from "@mui/material";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";
import { PermissionChecker } from "../../../../../services/varianceService/util/PermissionChecker";

interface IncidentDescriptionProps {
  canEdit: boolean;
}

function IncidentDescription({ canEdit }: IncidentDescriptionProps) {
  const dispatch = useAppDispatch();
  const description = useAppSelector(
    (state) => state.varianceRequest.varianceRequest.description
  );
  const variance = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );
  const myProfile = useMyProfileQuery();
  const [value, setValue] = useState(description);
  
  // Check if incident has been submitted to quality team (Pending status or later)
  const isSubmittedToQuality = Boolean(variance.status && 
    ['Pending', 'PendingApproval', 'Assigned', 'Approved', 'Complete', 'Rejected'].includes(variance.status));
  
  // IncidentAdmin can edit description for all statuses
  const isIncidentAdmin = myProfile.data?.claimsAccess?.find(p => p.code === 'IncidentAdmin') !== undefined;
  
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    dispatch(
      editVariance(new ReduxUpdate('description', e.target.value))
    );
  };
  
  return (
    <React.Fragment>
      <TextField
        multiline
        rows={20}
        variant="outlined"
        fullWidth
        value={value}
        onChange={onChange}
        disabled={!canEdit || (isSubmittedToQuality && !isIncidentAdmin)}
        placeholder="Please enter a description of the incident"
        helperText={isSubmittedToQuality && !isIncidentAdmin ? "Description cannot be edited after submission to quality team" : undefined}
      />
    </React.Fragment>
  );
}

export { IncidentDescription };
